var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgressIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.662662 13.9317C0 13.9317 0 13.9776 0 13.7521L0 8.60726C0 8.38171 0.296684 8.19886 0.662662 8.19886C1.02864 8.19886 1.32532 8.38171 1.32532 8.60726V13.7523C1.32532 13.9778 1.32532 13.9317 0.662662 13.9317Z",
    fill: "#0B1A8E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.90368 13.9302C3.97595 13.9302 3.97595 13.9563 3.97595 13.6284V6.21203C3.97595 5.88414 4.39131 5.61833 4.90368 5.61833C5.41605 5.61833 5.83141 5.88414 5.83141 6.21203V13.6287C5.83141 13.9566 5.83141 13.9302 4.90368 13.9302Z",
    fill: "#0B1A8E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.80744 13.9305C8.61468 13.9305 8.61467 13.9498 8.61467 13.5388V4.25523C8.61467 3.84419 9.14869 3.51097 9.80744 3.51097C10.4662 3.51097 11.0002 3.84419 11.0002 4.25523L10.9443 13.5384C10.9443 13.9495 10.9443 13.9305 9.80744 13.9305Z",
    fill: "#0B1A8E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7107 13.9256C13.2528 13.9256 13.2528 14.0059 13.2528 13.5258V2.62419C13.2528 2.14406 13.9055 1.75484 14.7107 1.75484C15.5158 1.75484 16.1685 2.14406 16.1685 2.62419V13.5258C16.1685 14.0059 16.1685 13.9256 14.7107 13.9256Z",
    fill: "#0B1A8E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2771 13.9273C18.5542 13.9273 18.5542 14.001 18.5542 13.4607V1.21104C18.5542 0.67081 19.3256 0.232867 20.2771 0.232867C21.2287 0.232867 22 0.67081 22 1.21104V13.4609C22 14.0012 22 13.9273 20.2771 13.9273Z",
    fill: "#0B1A8E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.1794 11.3496L20.8205 4.59043M20.8205 4.59043L17.1163 3.88613M20.8205 4.59043L18.9585 7.12575",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressIcon);
export default __webpack_public_path__ + "static/media/progressIcon.fa1ca90d6a187d5b01f2fd5dd07ea48d.svg";
export { ForwardRef as ReactComponent };